import { render, staticRenderFns } from "./InquiryDetailPage.vue?vue&type=template&id=a95b6758&scoped=true&"
import script from "./InquiryDetailPage.vue?vue&type=script&lang=js&"
export * from "./InquiryDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./InquiryDetailPage.vue?vue&type=style&index=0&id=a95b6758&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95b6758",
  null
  
)

export default component.exports